module.exports = __webpack_public_path__ + "static/img/logo_longhua.76f35463.png";